import './ClientAnalytics.css';
import AnalyticsTable from './AnalyticsTable/AnalyticsTable';
import { Spinner } from 'react-bootstrap';
import * as chartAPIRequests from '../../shared/requests/teamAnalyticsChartRequests';
import { chartTypeEnum } from './constants';
import dayjs from '../../utils/dayjs';
import { Chart } from 'chart.js';
import { useDropdownTable } from '../../shared/hooks/useDropdownTable';
import { AddOnTypes } from '../../shared/constants/TenantFields';

function TeamAnalytics() {
  const { data } = useDropdownTable({});
  const dropdownTable = data ?? 'loading';

  const now = dayjs().endOf('day');
  const defaultQuery = `endDate=${now.toISOString()}`;

  const returnChartsArrayData = () => {
    return [
      {
        title: 'Total Media Interactions',
        plotly: 0,
        networkRequest: chartAPIRequests.getMediaInteractionsChart,
      },
      {
        title: 'Issue Response Media Interactions',
        plotly: 0,
        type: chartTypeEnum.barVertical,
        networkRequest: chartAPIRequests.getIssueResponseMIChart,
      },
      {
        title: 'Team Driven Media Interactions',
        plotly: 0,
        type: chartTypeEnum.barPercentage,
        networkRequest: chartAPIRequests.getTeamDrivenMIChart,
      },
      {
        title: 'Institutional Story Media Interactions',
        plotly: 0,
        type: chartTypeEnum.barVertical,
        networkRequest: chartAPIRequests.getInstitutionalStoryMIChart,
      },
      {
        title: 'Proactive Client Media Interactions',
        plotly: 0,
        type: chartTypeEnum.barVertical,
        networkRequest: chartAPIRequests.getProactiveMIChart,
      },
      {
        title: 'Proactive Media Relations Tactics',
        plotly: 0,
        networkRequest: chartAPIRequests.getProactiveMRChart,
      },
      {
        title: 'Total Reactive Services',
        plotly: 0,
        type: chartTypeEnum.barVertical,
        networkRequest: chartAPIRequests.getReactiveServicesChart,
      },
      {
        title: 'Proactive Services',
        plotly: 0,
        networkRequest: chartAPIRequests.getProactiveServicesChart,
      },
      {
        title: 'Issues Complexity',
        plotly: 0,
        type: chartTypeEnum.barVertical,
        networkRequest: chartAPIRequests.getIssueComplexityChart,
      },
      {
        title: 'Total Engagements',
        plotly: 0,
        type: chartTypeEnum.barVertical,
        networkRequest: chartAPIRequests.getEngagementsChart,
        addOn: AddOnTypes.engagementLog,
      },
      {
        title: 'Total Community Members Engaged',
        plotly: 0,
        type: chartTypeEnum.barVertical,
        networkRequest: chartAPIRequests.getTotalCommunityMembersChart,
        addOn: AddOnTypes.engagementLog,
      },
      {
        title: `Tone of Interactions`,
        type: chartTypeEnum.stackedBarVertical,
        networkRequest: chartAPIRequests.getToneOfInteractionsChart,
        isYearlyChart: true,
      },
      {
        title: `Media Interactions by Campaign`,
        plotly: 0,
        type: chartTypeEnum.barWide,
        networkRequest: chartAPIRequests.getCampaignsMIChart,
        isYearlyChart: true,
      },
      {
        title: `Services by Campaign`,
        plotly: 0,
        type: chartTypeEnum.barWide,
        networkRequest: chartAPIRequests.getCampaignsServiceChart,
        isYearlyChart: true,
      },
      {
        title: `Engagements by Campaign`,
        plotly: 0,
        type: chartTypeEnum.barWide,
        networkRequest: chartAPIRequests.getCampaignsEngagementChart,
        addOn: AddOnTypes.engagementLog,
        isYearlyChart: true,
      },
    ];
  };

  const returnTablesDataArray = () => {
    return [];
  };
  window.addEventListener('beforeprint', () => {
    for (let id in Chart.instances) {
      Chart.instances[id].resize(600, 240);
    }
  });
  window.addEventListener('afterprint', () => {
    for (let id in Chart.instances) {
      Chart.instances[id].resize();
    }
  });

  return (
    <div className="analytics-wrapper">
      {dropdownTable !== 'loading' ? (
        <div className={'analytics-charts'}>
          <AnalyticsTable
            chartDataArray={returnChartsArrayData()}
            tableDataArray={returnTablesDataArray()}
            query={defaultQuery}
          ></AnalyticsTable>
        </div>
      ) : (
        <Spinner animation="border"></Spinner>
      )}
    </div>
  );
}

export default TeamAnalytics;
